import type { VoidFunctionComponent } from 'react';
import FallbackImage from '../generic/FallbackImage';

export const NetworkError: VoidFunctionComponent = () => (
  <FallbackImage src="error-plug" alt="Network error" hasPadding>
    <div>Oops! There was an error.</div>
    <div>Please try again in a bit.</div>
  </FallbackImage>
);

export const InvalidPermissionError: VoidFunctionComponent = () => (
  <FallbackImage src="no-results" alt="No results" hasPadding>
    <div>You do not have permission to access this page. Please contact your FOSSA administrator to get access.</div>
  </FallbackImage>
);
